import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  BillingPortalSession,
  MutationCreateBillingPortalSessionArgs,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  type UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useTribeClient } from '../../useTribeClient.js'

export const useCreateBillingPortalSession = (options?: {
  useMutationOptions?: UseMutationOptions<
    BillingPortalSession,
    ClientError,
    MutationCreateBillingPortalSessionArgs
  >
}) => {
  const { useMutationOptions } = options || {}
  const { client } = useTribeClient()

  return useMutation<
    BillingPortalSession,
    ClientError,
    MutationCreateBillingPortalSessionArgs
  >(
    input =>
      client.mutation({
        name: 'createBillingPortalSession',
        args: {
          fields: 'basic',
          variables: input,
        },
      }),
    useMutationOptions,
  )
}
